/**
 * Hooks for managing document tags
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { erp } from "@/lib/erp";

export function useAddTag(doctype: string, name: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tag: string) => {
      return erp.docs.addTag(doctype, name, tag);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["doc-sidebar", doctype, name],
      });
    },
  });
}

export function useRemoveTag(doctype: string, name: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tag: string) => {
      return erp.docs.removeTag(doctype, name, tag);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["doc-sidebar", doctype, name],
      });
    },
  });
}

